import {isShopEnabled} from '~/composables/useShopFeature'
import {isShopCabinetPath, isShopStorefrontPath} from '~/utils/shopFeature'

export default defineNuxtRouteMiddleware((to) => {
    if (isShopEnabled()) {
        return
    }

    const {isShopHost, mainSiteUrl} = useShopHost()

    if (isShopHost.value) {
        return navigateTo(mainSiteUrl('/'), {external: true, redirectCode: 302})
    }

    if (!isShopStorefrontPath(to.path) && !isShopCabinetPath(to.path)) {
        return
    }

    throw createError({statusCode: 404, statusMessage: 'Not Found'})
})
